












































































































import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {ApiMessage, DateTime, PendingCardConfirm, PendingPhoneconfirm, PhoneNumber} from "../../modules/models";
import Userterms from "./../Userterms.vue";
import {firstOne} from "../../modules/utils";
import rd from "@/modules/vRoutedefs";
import BaseApi from "@/store/modules/base";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-userterms": Userterms
    }
})
export default class KeyLogin extends CommonBase {
    @Inject()
    api!: Api;
    @Inject()
    baseApi!: BaseApi;

    @Prop({default: ""})
    redir!: string;

    cardnum = 1;
    title = "Aktivering mobilnr";

    working = true;
    errMsg: string | null = null;
    pkey: string | null = null;
    ckey: string | null = null;
    ckeyMerges: boolean = false; // Set to true when ckey is used to merge a card user into another user.

    pendingPhoneconfirm: PendingPhoneconfirm | null = null;

    sessionPhone: PhoneNumber | null = null;

    pendingCardConfirm: PendingCardConfirm | null = null;

    async redirToNext() {
        // Try loading newly authenticated user into base state before redirect, so that router guard doesn't interfer
        await this.baseApi.loadUser();
        await ignoreRedundantNavErr(this.$router.push(this.nextTo));
    }
    get nextTo() {
        if(this.redir && this.redir != "") {
            return this.redir;
        }
        return {name: rd.start.name};
    }

    birthDateFormat(dt: DateTime): string {
        return dt != null ? dt.toLocalDate() : "";
    }

    confirmPersonPhoneNum() {
        if(this.pendingPhoneconfirm != null && this.pendingPhoneconfirm.existingPerson) {
            // Confirm pending phone for existing person
            this.confirmPKey(false);
        } else {
            // Show new user terms confirmation
            this.cardnum = 2;
        }
    }

    cancel() {
        this.cardnum = 3; // Show declined card
    }
    toLogin() {
        this.cardnum = 1; // Back to start incase the component is revisited
        ignoreRedundantNavErr(this.$router.push("/"));
    }

    async confirmPKey(termsAccepted: boolean) {
        if(this.pkey != null) {
            this.working = true;
            try {
                const confirmResult = await this.api.confirmLoginPKey(this.pkey, termsAccepted);
                if (confirmResult.num == 34) { // success
                    const loginResult = await this.api.pkeyLogin(this.pkey);
                    if (loginResult.num == 46) { // login ok
                        await this.redirToNext();
                        return; // Exits
                    } else {
                        this.errMsg = loginResult.msg;
                    }
                } else {
                    this.errMsg = confirmResult.msg;
                }
            } finally {
                this.working = false;
            }
        } else {
            this.errMsg = "Nøkkelverdi ikke utfyllt";
        }
    }

    termsDeclined() {
        this.snack("Brukervilkår avslått. Bruker ikke opprettet.");
        ignoreRedundantNavErr(this.$router.push("/"));
    }

    termsAccepted() {
        this.confirmPKey(true);
    }

    snack(txt: string) {
        this.$emit("at-snack", txt);
    }

    async confirmCardPhoneNum() {
        if(this.ckey != null) {
            this.working = true;
            try {
                const msg = await this.api.confirmPendingCardPhone(this.ckey, this.ckeyMerges);
                if (msg.num == 61 || msg.num == 63) {
                    if (msg.num == 61) { // Merge done
                        this.snack("Sammenslåing ok");
                    } else if (msg.num == 63) {
                        this.snack("Overtakelse av mobilnummer utført");
                    }
                    // Login with key and redirect to start
                    this.doCkeyLogin();

                } else { // Something did not work ok
                    this.errMsg = msg.msg + " Ta kontakt med Proresult for hjelp";
                }
            } finally {
                this.working = false;
            }
        } else {
            this.errMsg = "Nøkkelverdi ikke utfyllt";
        }
    }

    async doCkeyLogin() {
        if(this.ckey != null) {
            this.working = true;
            try {
                const loginMsg = await this.api.ckeyLogin(this.ckey);
                if (loginMsg.num == 46) { // Login ok
                    await this.redirToNext();
                    return; // Exits
                } else {
                    this.errMsg = loginMsg.msg;
                }
            } finally {
                this.working = false;
            }
        } else {
            this.errMsg = "Nøkkelverdi ikke utfyllt";
        }
    }

    async process() {
        try {
            if(this.pkey) {
                // Check if there is already a session with same phone as pkey.
                const keyCheck = await this.api.checkSessionLoginKey(this.pkey);
                // If yes, just redirect to startpage with current session
                if (keyCheck.num == 45) { // Already logged in
                    // Redirect to startpage
                    await this.redirToNext();
                    return; // Exits
                } else if (keyCheck.num == 55 || keyCheck.num == 56) { // Other session or no session
                    // Continue checking if pkey resolves to a pending person row
                    // If pending phone row, display the confirm form with user info.
                    this.pendingPhoneconfirm = await this.api.fetchPendingPhoneconfirm(this.pkey);

                    // If no pending row, try logging in with the pkey.
                    if (this.pendingPhoneconfirm == null) {
                        const loginResult = await this.api.pkeyLogin(this.pkey);
                        if (loginResult.num != 46) { // Login denied
                            this.errMsg = loginResult.msg;
                        } else {
                            // Redirect to startpage
                            await this.redirToNext();
                            return; // Exits
                        }

                    } else {
                        this.title = this.pendingPhoneconfirm.existingPerson ? "Bekreft brukertilknytning" : "Bekreft ny bruker";
                    }
                }
            } else if(this.ckey) {
                // Check if there is already a session with same phone as ckey.
                // If session exists and belongs to person that is already connected to pending card, redirect to startpage, nothing more needs to be done.
                const pendingConfirm = await this.api.fetchPendingCardConfirm(this.ckey);
                if(pendingConfirm instanceof ApiMessage) {
                    this.errMsg = pendingConfirm.num + ": " + pendingConfirm.msg;
                } else {
                    this.pendingCardConfirm = pendingConfirm;
                    this.ckeyMerges = pendingConfirm.mergeAllowed;
                }
            }

            // If we get here, login with key has not succeeded. Check if there is a current session to be used.
            this.sessionPhone = await this.api.sessionPhone();

        } finally {
            this.working = false;
        }
    }

    created() {
        this.pkey = firstOne(this.$route.query["pkey"]);
        this.ckey = firstOne(this.$route.query["ckey"]);
        if(!this.pkey && !this.ckey) {
            ignoreRedundantNavErr(this.$router.replace({name: "login"}));
        }
        this.process();
    }
}
